var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrange = function SvgOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#orange_svg__a)",
    d: "M143.225 56.08c-53.87-2.555-104.867 57.66-90.884 106.374s54 55.5 90.884 49.891c46.94-7.142 82.894-42.932 75.9-92.64s-54.925-62.632-75.9-63.626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#orange_svg__b)",
    d: "M91.972 176.184c.373-5.782-2.982-14.483-12.924-7.724 0 0-5.965 1.931-9.942 1.931s3.977 1.931 4.97 3.862c.995 1.931-1.988 6.758-.993 8.689s4.055-.965 5.01 0 .955 4.555.955 4.555 11.93 4.135 12.924-11.313"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "orange_svg__a",
    x1: 70.23,
    x2: 189.312,
    y1: 193.617,
    y2: 73.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101,
    stopColor: "#218CBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239,
    stopColor: "#3295C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#4FA4CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#78B9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    stopColor: "#ABD4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961,
    stopColor: "#E9F4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "orange_svg__b",
    x1: 86.888,
    x2: 68.124,
    y1: 167.144,
    y2: 195.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#027CB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A91BF"
  })))));
};
export default SvgOrange;